import { Directive, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';
import {
    VALID_EMAIL_REGEX,
    VALID_USERNAME_REGEX,
    VALID_PASSWORD_REGEX,
    VALID_SIMPLE_PWD_REGEX,
    VALID_ZIP_CODE_REGEX//,
    //VALID_INTL_PHONE_REGEX
} from './models/account-regex';

// validate against regex
export function regexValidator(regex: RegExp, patternType: string, ignoreEmpty: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        

        if (patternType && patternType != "") {

            switch (patternType.toLowerCase()) {
                case 'email':
                    regex = VALID_EMAIL_REGEX;
                    break;
                case 'username':
                    regex = VALID_USERNAME_REGEX;
                    break;
                case 'complexpassword':
                    regex = VALID_PASSWORD_REGEX;
                    break;
                case 'simplepassword':
                    regex = VALID_SIMPLE_PWD_REGEX;
                    break;
                case 'zipcode':
                    regex = VALID_ZIP_CODE_REGEX;
                    break;
                //case 'telephone':
                   // regex = VALID_INTL_PHONE_REGEX;
                  //  break;
                default:
                    break;
            }


        }

        if (ignoreEmpty)  {
            if (control.value == null || control.value.toString().length === 0)

            return null;
        }

        var isValid = regex.test(control.value);        
      

        return !isValid ? { 'regexPattern': { value: control.value } } : null;
        
    };
}



/**
 * @deprecated Use RegexMatchDirective
 */
@Directive({
    selector: '[regexPattern]',
   // providers: [{ provide: NG_VALIDATORS, useExisting: DynamicRequiredValidatorDirective, multi: true }]
})
export class RegexPatternDirective  {
    @Input()
    regexPattern: AbstractControl;

    @Input()
    regex: RegExp;

    @Input()
    patternType: string;

    @Input()
    ignoreEmpty: boolean = false;

   
    @HostListener('focusout', ['$event.target'])
    onFocusout(target) {

        this.validate();
    }

    @HostListener('document:triggerValidation', ['$event.target'])
    onsubmit() {
 
        this.validate();
    }

    validate() {
        

        if (!this.regexPattern.errors) {

            this.regexPattern.setErrors(regexValidator(this.regex, this.patternType, this.ignoreEmpty)(this.regexPattern));

        }
    }


}

